import { createContext, useState } from "react";

export const PAICProjectContext = createContext();

export const PAICProjectProvider = ({ children }) => {

    const [projectId, setProjectId] = useState(null);
    const [agentId, setAgentId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [groupName, setGroupName] = useState('');
    const [selectionId, setSelectionId] = useState(null);
    const [roleSBUniqueId, setRoleSBUniqueId] = useState(null);
    const [rolePositionCount, setRolePositionCount] = useState(null);
    const [roleTotalComp, setRoleTotalComp] = useState(null);
    const [viewByToggle, setViewByToggle] = useState(false);
    const [selectedVersionNumber, setSelectedVersionNumber] = useState(null);

    return (
        <PAICProjectContext.Provider
            value={{
                projectId,
                setProjectId,
                groupName,
                setGroupName,
                loading,
                setLoading,
                agentId,
                setAgentId,
                selectionId,
                setSelectionId,
                roleSBUniqueId,
                setRoleSBUniqueId,
                rolePositionCount,
                setRolePositionCount,
                roleTotalComp,
                setRoleTotalComp,
                viewByToggle,
                setViewByToggle,
                selectedVersionNumber,
                setSelectedVersionNumber,
            }}>
            {children}
        </PAICProjectContext.Provider>
    );
};